import React, { Fragment } from 'react';
import './withErrorMessage.scss';
import exclamationMark from 'assets/red-info.svg';

const withErrorMessage = Component => props => {
  const { error, ...rest } = props;
  return (
    <div className="with-error-message">
      <Component {...rest} />
      {error && (
        <>
          <img
            alt="error"
            src={exclamationMark}
            className="with-error-message__error-image"
          />
          <div className="with-error-message__error">{error}</div>
        </>
      )}
    </div>
  );
};

export {
  withErrorMessage,
};
